"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BadgeType = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _templateObject;
var BadgeType = exports.BadgeType = /*#__PURE__*/function (BadgeType) {
  BadgeType["Error"] = "error";
  return BadgeType;
}({});
var SIZES = {
  sm: '16px',
  // TODO: get real sizes
  md: '24px',
  lg: '32px',
  // XL TSize was needed, this is temporal.
  xl: '32px'
};

// TODO: get all possible types/ colors
var COLORS = (0, _defineProperty2["default"])({}, BadgeType.Error, _colors["default"].red50);
var HBBadge = function HBBadge(props) {
  return /*#__PURE__*/_react["default"].createElement(Badge, props);
};
var _default = exports["default"] = HBBadge;
var Badge = _styledComponents["default"].div.withConfig({
  displayName: "HBBadge__Badge",
  componentId: "sc-7i9raw-0"
})(["width:", ";height:", ";border-radius:", ";border:solid 3px ", ";background-color:", ";transform:scale(0) translate(50%,-50%);", " transition:transform 225ms cubic-bezier(0.4,0,0.2,1) 0ms;position:absolute;top:0;right:0;"], function (props) {
  return SIZES[props.size || 'sm'];
}, function (props) {
  return SIZES[props.size || 'sm'];
}, function (props) {
  return SIZES[props.size || 'sm'];
}, _colors["default"].white, function (props) {
  return COLORS[props.type];
}, (0, _styledIs["default"])('visible')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  \ttransform: scale(1) translate(50%, -50%);\n  "]))));
//# sourceMappingURL=HBBadge.js.map